import { useQuery } from '@tanstack/react-query';

import { request } from '@/utils/ajax';
import { ProjectTag, ProjectTagType, ProjectTagExtended } from '@/types';

export const getProjectTags = (projectId: number, type: ProjectTagType): Promise<ProjectTag[]> => {
    return request(`api/project/${projectId}/tags/${type}`).then((x) => x.json());
};

/** Fetches a project's tags of the given type. Disabled until projectId is known. */
export const useProjectTags = (projectId: number | undefined, type: ProjectTagType) => {
    return useQuery({
        queryKey: ['project-tags', projectId, type],
        queryFn: () => getProjectTags(projectId!, type),
        enabled: !!projectId,
    });
};

export const addProjectTags = (projectId: number, text: string, type: ProjectTagType): Promise<ProjectTag> => {
    return request(`api/project/${projectId}/tags/${type}`, {
        method: 'POST',
        body: {
            text,
        },
        json: true,
    }).then((x) => x.json());
};

export interface UpdateTagsRequestItem {
    id?: number;
    label: string;
    type?: ProjectTagType;
    sortOrder: number;
}

export const editProjectTags = (projectId: number, tags: UpdateTagsRequestItem[]): Promise<ProjectTag[]> => {
    return request(`api/project/${projectId}/tags/multiple`, {
        method: 'POST',
        body: {
            tags,
        },
        json: true,
    }).then((x) => x.json());
};

export const getProjectTagsExtended = (projectId: number): Promise<ProjectTagExtended[]> => {
    return request(`api/project/${projectId}/tags/extended`).then((x) => x.json());
};